export const dailyReset = 61200000;

export const weeklyReset = 493200 * 1000;

export const weekendStart = 147600 * 1000;

export const weekendEnd = 493200 * 1000;
